export default __webpack_public_path__ + "static/media/Brochure.1d502535.png";